export enum PageFetchError {
  NOT_FOUND = 'NOT_FOUND',
  RESPONSE_ERROR = 'RESPONSE_ERROR',
}

export const isNotFoundError = (err: unknown): boolean =>
  err === PageFetchError.NOT_FOUND ||
  (err instanceof Error && err.message === PageFetchError.NOT_FOUND);

export const escapeRegExp = (str: string): string =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
